module.exports = __webpack_public_path__ + "img/gauravrai.9d78cc69.jpeg";